exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-next {\n  float: right;\n}\n\nh4 {\n  margin-top: 10px;\n  font-weight: 700;\n}\n\nhr {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.label-value {\n  font-weight: 500;\n}\n\n.control-label {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/pages/organization-add/organization-add.component.css
// module id = ../../../../../src/app/main/pages/organization-add/organization-add.component.css
// module chunks = main